import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService, TokenInterface } from '../services';
import { environment } from '../../../environments/environment';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthInterceptor<T> implements HttpInterceptor {
    constructor(
        private readonly authenticationService: AuthenticationService,
    ) {
    }
    intercept(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        return this.authenticationService.getToken().pipe(
            take(1),
            switchMap((token: TokenInterface) => {
                if (token && req?.url.includes(environment.baseUrl)) {
                    const cloneRequest: HttpRequest<T> = req.clone({
                        setHeaders: {
                            'Authorization': `${token.key} ${token.value}`
                        },
                    });

                    return next.handle(cloneRequest);
                }
                return next.handle(req);
            })
        )
    }
}
